import { PathColour } from "./chainModel";

// The hue of each path colour: light, muted shades that read on the dark
// theme and stay apart from the accent blue, the warning amber and the edge
// grey
export const PATH_COLOUR_VALUES: Record<PathColour, string> = {
  violet: "#a78bfa",
  green: "#86efac",
  pink: "#f9a8d4",
  cyan: "#67e8f9",
  lime: "#d9f99d",
};
